import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { Footer } from "../../components/FooterV2";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";

import { useTranslation } from "react-i18next";
import { SolutionSceneScreen } from "../../blocks/aboutus-scroll";
import { FormContent } from "../../blocks/form-content";
import { Notice } from "../../components/Notice";

export const AuthingForm = () => {
  const { t } = useTranslation();
  return (
    <div className="authing-form">
      <Helmet>
        {/* <title>Authing招聘-加入Authing-Authing身份云</title> */}
      </Helmet>
      <Header />
      <FormContent />
      <Footer />
    </div>
  );
};
